import React, { useContext } from 'react'
import styles from './ExperienceYears.module.css'
import { ChoicesButton } from '../../../Common/CtaButton/ChoicesButton'
import { BackButton } from '../../../Common/CtaButton/BackButton'
import { StepContext } from '../../../Context/StepContext'
import { useAbTestGtm } from '../../../utils/abTest'

export const ExperienceYears = () => {
    const { handleNext, handlePrev, updateFormData, formData } = useContext(StepContext)

    const handleSelect = (years) => {
        updateFormData('experienceYears', years)
        handleNext()
    }

    const { dataViewLabel, dataClickLabel } = useAbTestGtm()

    return (
        <div className={styles.wrapper}>
            <div className={styles.title}>
                <BackButton dataClickLabel={dataClickLabel('EF_StepForm_Step2-経験年数-戻る')} onClick={handlePrev} />
                <h1
                    data-view-label={dataViewLabel('EF_StepForm_Step2-経験年数')}
                    className={styles.titleText}
                >
                    Q.業界の経験年数は何年ですか？
                </h1>            </div>
            <div className={styles.selectionWrapper}>
                <ChoicesButton
                    imageSrc='/entry_form_slide_app/steps/step2/one-year.png'
                    imageAlt='1年未満'
                    dataClickLabel={dataClickLabel('EF_StepForm_Step2-経験年数-1年未満')}
                    onClick={() => handleSelect('1年未満')}
                    selected={formData.experienceYears === '1年未満'}
                />
                <ChoicesButton
                    imageSrc='/entry_form_slide_app/steps/step2/five-year.png'
                    imageAlt='1~5年'
                    dataClickLabel={dataClickLabel('EF_StepForm_Step2-経験年数-1~5年')}
                    onClick={() => handleSelect('1~5年')}
                    selected={formData.experienceYears === '1~5年'}
                />
                <ChoicesButton
                    imageSrc='/entry_form_slide_app/steps/step2/ten-year.png'
                    imageAlt='5~10年'
                    dataClickLabel={dataClickLabel('EF_StepForm_Step2-経験年数-5~10年')}
                    onClick={() => handleSelect('5~10年')}
                    selected={formData.experienceYears === '5~10年'}
                />
                <ChoicesButton
                    imageSrc='/entry_form_slide_app/steps/step2/more-ten-year.png'
                    imageAlt='10年以上'
                    dataClickLabel={dataClickLabel('EF_StepForm_Step2-経験年数-10年以上')}
                    onClick={() => handleSelect('10年以上')}
                    selected={formData.experienceYears === '10年以上'}
                />
            </div>
        </div>
    )
}
